import { DropdownOptionsService } from '../../../../../../core/services/dropdown-options.service';
import { Component, EventEmitter, Injector, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Dialog } from 'primeng/dialog';
import { LogisticsService } from 'src/app/features/transport-operation/services/logistics.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { deepCopy, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as ValidationFuncs from 'src/app/core/utils/validation-functions';
import { HttpErrorResponse } from '@angular/common/http';
import { BookingService } from 'src/app/features/transport-operation/services/booking.service';



@Component({
  selector: 'laas-return-tms',
  templateUrl: './return-tms.component.html',
  styleUrls: ['./return-tms.component.scss']
})
export class ReturnTmsComponent  extends SessionBaseComponent implements OnInit, OnChanges {

  @Input() booking: any;
  @Output() visibleChange: EventEmitter<any>;
  @Output() returnTmsClick: EventEmitter<any>;
  @ViewChild(Dialog) dialog!: Dialog;

  @Input() tmsData: any;

  isVisible: boolean;
  columns: any[];
  params:any;

  submitted: boolean;

  constructor(
    injector: Injector,
    private logisticsService: LogisticsService,
    private bookingService: BookingService,
    private fb: FormBuilder) {

      super(injector);
      this.isVisible = false;

      this.columns = [
        { field: 'deliveryId', header: '交貨單號' },
        { field: 'message', header: '訊息' },
        { field: 'errorMessage', header: '錯誤訊息' },
        { field: 'createDt', header: '時間' }
      ];
      this.submitted = false;
      this.visibleChange = new EventEmitter<any>();
      this.returnTmsClick = new EventEmitter<any>();

  }

  ngOnChanges(changes: SimpleChanges): void {

  }

  @Input() get visible(): any {
    return this.isVisible;
  }

  set visible(value: any) {
    this.isVisible = value;
  }

  async ngOnInit(): Promise<void> {
    super.ngOnInit();
    console.log("ngOnInit tmsData:",this.tmsData);
  }

  cancelBtnClick(event: any): void {
    this.dialog.close(event);
  }

  dialogVisibleChange(event: any): void {
    this.visibleChange.emit(event);
  }

}
